import React, {useContext, useEffect, useRef, useState} from 'react';
import hand from '../assets/images/hand.svg';
import axios from "axios";
import {baseUrl} from "../api/network";
import {useShallowPickSelector} from "../redux";
import {toast} from "react-toastify";
import toastOptions from "../data/ToastOptions";
import {useDispatch} from "react-redux";
import * as Appstore from '../redux/app';
import Timer from "../components/Timer";
import * as AppStore from "../redux/app";
import CircularProgressBar from "../components/circleProgressBar";
import CircularProgressBar1 from "../components/circleProgressBar1";
import {HeaderContext} from "../components/layout/Layout";

let timeout;
let timeout1;
let timeout2;

const HiJet = () => {
    const {pointRect} = useContext(HeaderContext);
    const {mainData} = useShallowPickSelector('app', ['mainData']);
    const [mainDataVal, setMainDataVal] = useState(mainData);
    const {tgUser} = useShallowPickSelector('user', ['tgUser']);
    const dispatch = useDispatch();
    const [scores, setScores] = useState([]);
    const [mainTimeValue, setMainTimeValue] = useState(mainDataVal?.hi_jet?.can_use ? 0 : mainDataVal?.hi_jet?.available_date * 1000);
    const myDivRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(100);

    useEffect(() => {
        setLoading(false);
        if (mainData?.hi_jet?.available_date >= 0) {
            setMainDataVal(mainData)
        } else {
            dispatch(Appstore.getPointsDataFn())
        }
    }, [mainData])

    useEffect(() => {
        return () => {
            clearTimeout(timeout);
            clearTimeout(timeout1);
            clearTimeout(timeout2);
        }
    }, []);

    const getPointAnimation = (e) => {
        if (mainDataVal?.hi_jet?.can_use && progress > 0) {
            const progressValue = progress - mainDataVal?.hi_jet?.point_per_click
            setProgress(progressValue);
            const rect = myDivRef.current?.getBoundingClientRect();

            const clickX = e.clientX;
            const clickY = e.clientY;

            const relativeX = clickX - rect.left;
            const relativeY = clickY - rect.top;

            setScores((prevScores) => [
                ...prevScores,
                { id: Date.now(), x: relativeX, y: relativeY, clickX, clickY, value: mainDataVal?.hi_jet_point }
            ]);

            timeout1 = setTimeout(() => {
                setScores((prevScores) => prevScores.filter((score) => score.id !== Date.now()));
            }, 3000);

            if (progressValue === 0) {
                fetchDataFn()
            }
        }
    }

    const fetchDataFn = () => {
        setLoading(true)
        const headers = {
            'Content-Type': 'application/json',
        }
        const lastData = {
            user_tg_id: tgUser?.id,
        }

        axios.post(`${baseUrl}/points/store/hi-jet`, JSON.stringify(lastData), {headers})
            .then((response) => {
                if (response.data.status === '1') {
                    dispatch(Appstore.getPointsDataFn((val) => {
                        setLoading(false)
                        dispatch(AppStore.actions.setShowCelebrate(true))
                        if (val?.hi_jet?.can_use) {
                            setMainTimeValue(0)
                        } else {
                            setMainTimeValue(val?.hi_jet?.available_date * 1000)
                        }
                    }))
                } else if (response.data.status === '0' && response.data.message === 'ALREADY_USED') {
                    setLoading(false)
                    timeout = setTimeout(() => {
                        // toast.error('You have used your quota for today. Please wait until the next turn.', toastOptions);
                    }, 500)
                } else {
                    setLoading(false)
                    toast.error('Something went wrong! Please try again.', {...toastOptions, toastId: 17})
                }
            })
            .catch(() => {
                setLoading(false)
                toast.error('Something went wrong! Please try again.', {...toastOptions, toastId: 18})
            })
    }

    const onCompleteFn = () => {
        setLoading(true);
        timeout2 = setTimeout(() => {
            dispatch(Appstore.getPointsDataFn((val) => {
                setLoading(false)
                setScores([]);
                setProgress(100)
                if (val?.hi_jet?.can_use) {
                    setMainTimeValue(0)
                } else {
                    setMainTimeValue(val?.hi_jet?.available_date * 1000)
                }
            }))
        }, 500)
    }

    return (
        <div className="center hiJet-container relative">
            <div className="hiJet_btn_container">
                {mainDataVal?.hi_jet?.can_use && <div className="hiJet-circle">
                    <CircularProgressBar progress={progress} size={220} strokeWidth={8} color="#cb8000">
                        <button ref={myDivRef} type="button" className="hiJet-button" onClick={getPointAnimation}>
                            <div className="center">
                                <img alt="Jet Point" src={hand} className="hiJet-icon" />
                                <span className="text-white font-bold fs16 ml5">Hi JET</span>
                            </div>
                            {scores.map((score) => {
                                return (
                                    <div
                                        key={score.id}
                                        className="score"
                                        style={{ left: score.x, top: score.y, transform: `translate(${-score?.clickX + pointRect.left}px, ${-score?.clickY + pointRect.top}px)`, }}
                                    >
                                        <p className="fs24">+{mainDataVal?.hi_jet?.point_per_click}</p>
                                    </div>
                                )
                            })}
                            {mainDataVal?.hi_jet?.point !== 0 && <span
                                className="text-white fs16 font-bold mt20">{`Get ${mainDataVal?.hi_jet?.point} Point`}</span>}
                            {mainDataVal?.hi_jet?.point === 0 && <span
                                className="text-white fs16 font-bold mt20">Please Wait for</span>}
                            <Timer mainTime={mainTimeValue} />
                            {loading && (
                                <div className="hiJet-LoadingOverlay">
                                    <div className="center"><div className="loader"></div></div>
                                </div>
                            )}
                        </button>
                    </CircularProgressBar>
                </div>}
                {!mainDataVal?.hi_jet?.can_use && (
                    <CircularProgressBar1 endTime={mainTimeValue} totalDuration={mainDataVal?.hi_jet?.round_sec} size={220} strokeWidth={8} color="#cb8000" onComplete={onCompleteFn}>
                        <button ref={myDivRef} type="button" className="hiJet-button relative" onClick={getPointAnimation}>
                            <div className="center">
                                <img alt="Jet Point" src={hand} className="hiJet-icon" />
                                <span className="text-white font-bold fs16 ml5">Hi JET</span>
                            </div>
                            {/*{scores.map((score) => (*/}
                            {/*    <div*/}
                            {/*        key={score.id}*/}
                            {/*        className="score"*/}
                            {/*        style={{ left: score.x, top: score.y }}*/}
                            {/*    >*/}
                            {/*        <p className="fs24">+{mainDataVal?.hi_jet?.point_per_click}</p>*/}
                            {/*    </div>*/}
                            {/*))}*/}
                            {mainDataVal?.hi_jet?.point !== 0 && <span
                                className="text-white fs16 font-bold mt20">{`Get ${mainDataVal?.hi_jet?.point ?? '0'} Point`}</span>}
                            {mainDataVal?.hi_jet?.point === 0 && <span
                                className="text-white fs16 font-bold mt20">Please Wait for</span>}
                            <Timer mainTime={mainTimeValue} />
                            {loading && (
                                <div className="hiJet-LoadingOverlay">
                                    <div className="center"><div className="loader"></div></div>
                                </div>
                            )}
                        </button>
                    </CircularProgressBar1>
                )}
            </div>
        </div>
    );
}

export default HiJet;
